<template>
	<!-- 添加用户弹框 -->
	<el-dialog title="添加用户" width="50%" :visible.sync="userAddVisible" :close-on-click-modal="false">
		<el-form ref="userAddForm" :model="user" label-width="100px" :rules="userAddRules">
			<el-form-item prop="selectRoles" label="岗位">
				<el-select v-model="user.selectRoles" multiple placeholder="请选择岗位" @change="selectChange" clearable>
					<el-option v-for="item in roleList" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>
			</el-form-item>

			<el-form-item prop="shift" label="班次">
				<el-select v-model="user.shift" placeholder="请选择班次" @change="selectChangeShift" clearable>
					<el-option v-for="item in shiftList" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>
			</el-form-item>

			<el-form-item prop="cardNumber" label="卡号">
				<el-input v-model="user.cardNumber" placeholder="请输入卡号" />
			</el-form-item>
			<el-form-item prop="username" label="用户名">
				<el-input v-model="user.username" placeholder="请输入用户名" />
			</el-form-item>
			<el-form-item prop="password" label="密码" v-if="canLogin">
				<el-input v-model="user.password" type="password" placeholder="请输入密码" show-password />
			</el-form-item>
			<el-form-item prop="phone" label="手机号">
				<el-input v-model="user.phone" placeholder="请输入手机号" />
			</el-form-item>
			<el-form-item prop="roleId" label="角色">
				<el-select v-model="user.roleId" placeholder="请选择角色" @change="selectChange1" clearable>
					<el-option v-for="item in role" :key="item.id" :label="item.roleName" :value="item.id" />
				</el-select>
			</el-form-item>
			<el-form-item prop="enableLogon" label="允许登录">
				<el-checkbox v-model="user.enableLogon"></el-checkbox>
			</el-form-item>
		</el-form>
		<div slot="footer">
			<el-button type="primary" @click="onSubmit">创建</el-button>
			<el-button @click="userAddVisible = false">取消</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import * as api from "@/api/factory/user/list";
	export default {
		name: "UserAdd",
		data() {
			return {
				userAddVisible: false,
				user: {
					username: "",
					phone: null,
					password: "",
					cardNumber: null,
					role: 0, //hongmj: 疑似岗位的叠加?
					selectRoles: [], //岗位(可多个)
					shift: "", //班次
					roleId: null, //角色
					enableLogon: null,
				},
				role: [], //角色列表

				roleList: [], //岗位列表
				shiftList: [], //班次列表
				canLogin: false,
				userAddRules: {
					//   验证用户名是否合法
					username: [{
							required: true,
							message: "请输入用户名",
							trigger: "blur"
						},
						{
							min: 1,
							max: 15,
							message: "长度在1 到 15 个字符之间",
							trigger: "blur",
						},
					],
					//   验证密码是否合法
					password: [{
							required: true,
							message: "请输入密码",
							trigger: "blur"
						},
						{
							min: 1,
							max: 15,
							message: "长度在1 到 15 个字符之间",
							trigger: "blur",
						},
					],
					// phone: [
					//   { required: true, message: '请输入手机号', trigger: 'blur' },
					//   { validator: this.$valid.checkPhone, trigger: 'blur' }
					// ],
					selectRoles: [{
						required: true,
						message: "请选择岗位",
						trigger: "blur"
					}, ],
					shift: [{
						required: true,
						message: "请选择班次",
						trigger: "blur"
					}, ],
					roleId: [{
						required: true,
						message: "请选择角色",
						trigger: "blur"
					}],
				},
			};
		},
		methods: {
			// 外部调用，展示添加用户弹框
			show() {
				this.userAddVisible = true;
			},
			// 初始化岗位选择框
			initRoleList() {
				const roleList = [];
				const roleObj = this.$enum.roleObj;
				for (var key in roleObj) {
					const obj = roleObj[key];
					roleList.push({
						value: obj.value,
						label: obj.name
					});
				}
				this.roleList = roleList;
			},
			// 岗位选择框，内容改变事件
			selectChange(val) {},
			//----------
			// 初始化角色列表
			initRoleList1() {
				api.getRole().then((res) => {
					console.log(res);
					this.role = res.data;
					console.log(this.role);
				});
			},
			// 角色选择框，内容改变事件
			selectChange1(val) {},

			//----------STA
			// 初始化班次选择框
			initShiftList() {
				const shiftList = [];
				const shiftObj_value = this.$enum.shiftObj_value;
				for (var key in shiftObj_value) {
					const obj = shiftObj_value[key];
					shiftList.push({
						value: obj.value,
						label: obj.name
					});
				}
				this.shiftList = shiftList;
			},
			// 班次选择框，内容改变事件
			selectChange_shift(val) {},
			//----------END
			// 点击创建按钮，创建用户
			onSubmit() {
				this.$refs.userAddForm.validate((valid) => {
					if (!valid) return;
					const clone = this._.cloneDeep(this.user);
					clone.phone = this.utils.isEmpty(clone.phone) ? null : clone.phone;
					clone.cardNumber = this.utils.isEmpty(clone.cardNumber) ?
						null :
						clone.cardNumber;
					api.addUser(clone).then((res) => {
						this.$refs.userAddForm.resetFields();
						this.$emit("update");
						this.userAddVisible = false;
						this.$Message.success("添加用户成功！");
					});
				});
			},
		},
		watch: {
			// 监听选择的角色，因为可以多角色，所以要把选中的角色枚举相加
			"user.selectRoles"(val) {
				var selectEnum = 0;
				this.canLogin = false;
				val.forEach((roleEnum) => {
					roleEnum = parseInt(roleEnum);
					if (roleEnum === this.$enum.roleObj.admin.value) {
						this.canLogin = true;
					}
					selectEnum += roleEnum;
				});
				console.log(selectEnum);
				this.user.role = selectEnum;
			},
		},
		mounted() {
			this.initRoleList(); //初始化岗位选择框
			this.initRoleList1(); //初始化角色列表

			this.initShiftList(); //初始化班次选择框
		},
	};
</script>

<style lang="less" scoped>
	.el-select {
		width: 100%;
	}
</style>